import { availabilityOption, conditionOption, intervalOption } from "../../../common/facebook";
import { getFacebookProperties } from "./thunk";

export const facebook = {
  state: {
    id: null,
    title: {
      value: '',
      isFeed: false,
    },
    description: {
      value: '',
      isFeed: false,
    },
    availability: {
      ...availabilityOption[0],
      isFeed: false,
    },
    condition: {
      ...conditionOption[0],
      isFeed: false,
    },
    price: {
      value: '',
      isFeed: false,
    },
    link: {
      value: '',
      isFeed: false,
    },
    image_link: {
      value: '',
      isFeed: false,
    },
    interval: intervalOption[0],
    exportType: 'image',
    limit: 5,
    isFacebookPropertiesSet: false,
    facebookStatus: false,
    facebookId: null,
    selectedFacebookProperty: null,
    facebookPublishMessage: null,
    facebookCreativeIds: [],
  },
  reducers: {
    setProperties(state, action) {  
      if (action.payload) {
        state.facebookId = (action.payload?._id || state.facebookId);
        state.id = (action.payload?.properties?.id || null);
        state.title = action.payload?.properties?.title;
        state.description = action.payload?.properties?.description;
        state.availability = action.payload?.properties?.availability;
        state.condition = action.payload?.properties?.condition;
        state.price = action.payload?.properties?.price;
        state.link = action.payload?.properties?.link;
        state.image_link = action.payload?.properties?.image_link;
        state.brand = action.payload?.brandId;
        state.interval = action.payload?.interval;
        state.exportType = 'image';
        state.limit = action.payload?.limit;  
      }
    },
    setSelectedFacebookProperty(state, action) {
      state.selectedFacebookProperty = action.payload;
    },
    setFacebookPropertyFeed(state, action) {
      state[state.selectedFacebookProperty] = action.payload;
    },
    setFacebookId(state, action) {
      state.facebookId = action.payload;
    },
    setIsFacebookProperties(state, action) {
      state.isFacebookPropertiesSet = action.payload;
    },
    setFacebookStatus(state, action) {
      state.facebookStatus = action.payload;
    },
    setFacebookCreativeIds(state, action) {
      state.facebookCreativeIds = action.payload;
    },
    resetFacebook(state, action) {
      state.id = {
        value: null,
        isFeed: false,
      }
      state.title = {
        value: '',
        isFeed: false,
      };
      state.description = {
        value: '',
        isFeed: false,
      };
      state.availability = {
        ...availabilityOption[0],
        isFeed: false,
      };
      state.condition = {
        ...conditionOption[0],
        isFeed: false,
      };
      state.price = {
        value: '',
        isFeed: false,
      };
      state.link = {
        value: '',
        isFeed: false,
      };
      state.image_link = {
        value: '',
        isFeed: false,
      };
      state.interval = intervalOption[0];
      state.exportType = 'image';
      state.limit = 5;
      state.isFacebookPropertiesSet = false;
      state.facebookStatus = false;
      state.facebookId = null;
      state.selectedFacebookProperty = null;
      state.facebookPublishMessage = null;
      state.facebookCreativeIds = [];
    },
    setFacebookPublishMessage(state, action) {
      state.facebookPublishMessage = action.payload;
    }
  },
  getExtraReducers: (builder) => {
    builder.addCase(getFacebookProperties.fulfilled, (state, action) => {
      if (action.payload) {
        state.facebookStatus = action.payload?.status;
        state.id = action.payload?.properties?.id;
        state.title = action.payload?.properties?.title;
        state.description = action.payload?.properties?.description;
        state.availability = action.payload?.properties?.availability;
        state.condition = action.payload?.properties?.condition;
        state.price = action.payload?.properties?.price;
        state.link = action.payload?.properties?.link;
        state.image_link = action.payload?.properties?.image_link;
        const foundInterval = intervalOption.find(item => item.value === action.payload?.interval);
        state.interval = foundInterval;
        state.exportType = 'image';
        state.limit = action.payload?.limit;
        state.facebookId = action.payload?._id;
        state.isFacebookPropertiesSet = true;
        state.facebookCreativeIds = action.payload?.creativeIds;
      }
    });
  }
}